import { type FilterItem } from '@/infra/FiltersViewModel'
import { type JobProgressionStepFilterOption } from '@/features/jobs/list/job-progression-filter-option'
import { type JobScopeChangeStatusFilterOption } from '@/features/jobs/list/job-scope-change-status-filter-option'
import { type JobStatusFilterOption } from '@/features/jobs/list/job-status-filter-option'
import { type JobPeriodFilterOption } from '@/features/jobs/list/job-period-filter-option'
import { type WaitingOn } from '@/features/jobs/Job'

/**
 * Options for the job status filter.
 */
export const StatusOptions: FilterItem<JobStatusFilterOption>[] = [
  {
    title: 'Unclaimed',
    value: 'Unclaimed',
  },
  {
    title: 'Closed',
    value: 'Closed',
  },
  {
    title: 'Info Gathering',
    value: 'InfoGathering',
  },
  {
    title: 'Idle',
    value: 'Idle',
  },
  {
    title: 'In Progress',
    value: 'InProgress',
  },
  {
    title: 'Onboarding',
    value: 'Onboarding',
  },
  {
    title: 'On Hold',
    value: 'OnHold',
  },
  {
    title: 'Pending',
    value: 'Pending',
  },
]

/**
 * Options for the progression step filter.
 */
export const ProgressionStepOptions: FilterItem<JobProgressionStepFilterOption>[] =
  [
    {
      title: 'None',
      value: 'None',
    },
    {
      title: 'Review documents',
      value: 'NotStarted',
    },
    {
      title: 'Open items',
      value: 'OpenItems',
    },
    {
      title: 'Job started',
      value: 'JobStarted',
    },
    {
      title: 'Draft review',
      value: 'DraftInReview',
    },
    {
      title: 'Changes requested',
      value: 'DraftRejected',
    },
    {
      title: 'Draft approved',
      value: 'DraftApproved',
    },
    {
      title: 'Authorization requested',
      value: 'AuthorizationRequested',
    },
    {
      title: 'Authorization received',
      value: 'AuthorizationSigned',
    },
    {
      title: 'Return filed',
      value: 'ReturnFiled',
    },
    {
      title: 'Preparation complete',
      value: 'PreparationCompleted',
    },
    {
      title: 'Review complete',
      value: 'ReviewCompleted',
    },
    {
      title: 'Extension in progress',
      value: 'ExtensionInProgress',
    },
    {
      title: 'Extension confirmed',
      value: 'ExtensionConfirmed',
    },
    {
      title: 'Extension accepted',
      value: 'ExtensionAccepted',
    },
    {
      title: 'Extension rejected',
      value: 'ExtensionRejected',
    },
    {
      title: 'Waiting on client',
      value: 'WaitingOnClient',
    },
    {
      title: 'Ready to file',
      value: 'ReadyToFile',
    },
  ]

/**
 * Options for the job scope change request status filter.
 */
export const JobScopeUpdatesOptions: FilterItem<JobScopeChangeStatusFilterOption>[] =
  [
    {
      title: 'Pending review',
      value: 'PendingReview',
    },
    {
      title: 'Accepted',
      value: 'Accepted',
    },
    {
      title: 'Rejected',
      value: 'Rejected',
    },
  ]

/**
 * Options for the job period filter.
 */
export const JobPeriodOptions: FilterItem<JobPeriodFilterOption>[] = [
  {
    title: 'All jobs',
    value: 'All',
  },
  {
    title: 'Current jobs',
    value: 'Current',
  },
  {
    title: 'Old jobs',
    value: 'Old',
  },
]

/**
 * Options for the waiting on filter.
 */
export const WaitingOnOptions: FilterItem<WaitingOn>[] = [
  { title: 'Pro', value: 'Provider' },
  { title: 'Client', value: 'Client' },
]
